import type { GetWebcastQuery } from '../../../../generated/graphql-manager';

export type AlignedWebcastData = {
  name: string;
  durationInMinutes: string;
  startingHour: string;
  startingMinutes: string;
  date: Date;
  themeId?: string | null;
  hideWebcastScheduleInViewer?: boolean;
};

/**
 * Normalizes backend webcast data to the shape used by the form.
 */
export function alignedWebcastDataFromBackend(webcast: GetWebcastQuery['webcast']): AlignedWebcastData {
  const { name, plannedStartAt, durationInMinutes, themeId, hideWebcastScheduleInViewer } = webcast;

  const date = new Date(plannedStartAt);
  const timeInHours = date.getHours().toString();
  const timeInMinutes = date.getMinutes().toString();
  date.setHours(0, 0, 0);

  return {
    name,
    durationInMinutes: String(durationInMinutes),
    startingHour: timeInHours,
    startingMinutes: timeInMinutes,
    date,
    themeId,
    hideWebcastScheduleInViewer,
  };
}
